export const routes = {
  login: '/login',
  forgotPw: '/login/forgot',
  register: '/login/register',
  profile: '/profile',
  profileEdit: '/profile/edit',
  dashboard: '/dashboard',
  accountingsTemp: '/accountings/temp',
  accountingsPosted: '/accountings',
  changePw: '/profile/change-password',
  resetPw: '/reset-password',
  documents: '/documents',
  statistics: '/statistics',
  registerEnrolment: '/register-enrolment',
  registeredEnrolments: '/registered-enrolments',
  myCattle: '/cattle',
  brandingClothes: '/branding-clothes',
  returnFormHelp:'/return-form'
};
